import { TemplatePage, TemplateSearch } from './TemplateChrome'
import type { TemplateProps } from './types'

const results = [
  { title: 'Renew a permit', url: '/services/renew', text: 'Renew online up to ninety days before your permit expires.', kind: 'Service' },
  { title: 'Apply for a permit', url: '/services/apply', text: 'Check eligibility and apply online in about twenty minutes.', kind: 'Service' },
  { title: 'Permit fees and waivers', url: '/fees', text: 'What a permit costs, and how to ask for a fee waiver.', kind: 'Guidance' },
  { title: 'Renewal form (PDF)', url: '/forms/renewal.pdf', text: 'Print, sign and mail this form to renew by mail.', kind: 'Form' },
  { title: 'Online renewals now open in every state', url: '/news/online-renewals', text: 'Renew from home with the new online service.', kind: 'News' },
]

const kinds = ['Service', 'Guidance', 'Form', 'News']

/** Results for a site search: the query, a count, filters, and results that say where each one leads. */
export default function SearchResults({ mission, link, credit }: TemplateProps) {
  return (
    <TemplatePage mission={mission} link={link} credit={credit}>
      <div className="mds-container mds-stack">
        <h1 className="mds-h1">Search results</h1>
        <TemplateSearch id="results-search" action={link('search-results')} value="permit" />
        <p className="mds-hint" role="status">
          {results.length} results for “permit”
        </p>
      </div>
      <div className="mds-container mds-page-layout">
        <form className="mds-stack" aria-label="Filter results">
          <fieldset className="mds-stack">
            <legend className="mds-label">Type</legend>
            {kinds.map((kind) => (
              <label key={kind} className="mds-choice">
                <input type="checkbox" name="type" value={kind.toLowerCase()} defaultChecked />
                {kind}
              </label>
            ))}
          </fieldset>
        </form>
        <div className="mds-stack">
          <ol className="mds-page-results">
            {results.map((result) => (
              <li key={result.url}>
                <article className="mds-stack">
                  <span className="mds-tag mds-tag--outline">{result.kind}</span>
                  <h2 className="mds-h3">
                    <a className="mds-link" href={result.kind === 'Service' ? link('service-landing') : '#results'}>
                      {result.title}
                    </a>
                  </h2>
                  <p className="mds-hint">{new URL(result.url, mission.url).href}</p>
                  <p>{result.text}</p>
                </article>
              </li>
            ))}
          </ol>
          <nav className="mds-pagination" aria-label="Results pages">
            <span className="mds-pagination__link" aria-disabled="true">
              Previous
            </span>
            <a className="mds-pagination__link" aria-current="page" aria-label="Page 1" href="#results">
              1
            </a>
            <a className="mds-pagination__link" aria-label="Page 2" href="#results">
              2
            </a>
            <a className="mds-pagination__link" href="#results">
              Next
            </a>
          </nav>
        </div>
      </div>
    </TemplatePage>
  )
}
